export default __webpack_public_path__ + "static/craig-cd06fccabb8908966a8699798418723f.jpg";